import React from "react";

export const PromoReminder = ({ handleApplyPromo, promotionalBonus }) => {
  return (
    <div className="ch-mv--2 ch-width--12">
      <div className="ch-rounded--lg ch-pa--3 ch-bg--grey-1 ch-width--12 ch-text--center">
        <button
          className="ch-btn ch-btn--secondary ch-width--12 ch-btn--md"
          onClick={handleApplyPromo}
        >
          Add £{promotionalBonus} to my valuation
        </button>
      </div>
    </div>
  );
};
